<template>
  <RygenChip class="manifest-status-chip" :label="label" :severity="severity" />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';

import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { ManifestStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<ManifestStatus | undefined>,
    default: () => undefined,
  },
});
const { status } = toRefs(props);

const label = computed((): string =>
  status?.value ? translateEnum(status.value, 'ManifestStatus') : '-',
);

const severity = computed((): Severity | undefined => {
  switch (status?.value) {
    case ManifestStatus.MANIFESTED:
      return Severity.SUCCESS;
    case ManifestStatus.FAILED:
      return Severity.DANGER;
    case ManifestStatus.CANCELED:
      return Severity.INFO;
    default:
      return undefined;
  }
});
</script>
